/* ============================================================
   PARCU — small behaviour tweaks
   Companion to assets/parcu-tweaks.css. Loaded from
   layout/theme.liquid. Keep this file small: it exists so a
   one-off change does not mean resending parcu-header.js.
   ============================================================ */

(function () {
    'use strict';

    /* --------------------------------------------------------
       PRODUCT PAGE — sticky bar adds to cart
       The theme renders the phone sticky bar (#add2cart-cta) as an
       anchor that jumps up to the size picker, labelled "Select
       option". A size is always preselected and the main button adds
       that size, so the sticky bar now does the same thing.

       The label is copied from the real button rather than hardcoded,
       which keeps it translated for every market and keeps it correct
       when the button says "Sold out" instead.
       -------------------------------------------------------- */

    function mainButton() {
        return document.querySelector('product-content form[action*="/cart/add"] [name="add"]')
            || document.querySelector('form[action*="/cart/add"] [name="add"]');
    }

    function labelOf(btn) {
        var cta = btn.querySelector('.cta');
        return ((cta ? cta.textContent : btn.textContent) || '').trim();
    }

    function wire() {
        var bar = document.getElementById('add2cart-cta');
        if (!bar) return;

        var link = bar.querySelector('a[href^="#variant-selects"]');
        var btn = mainButton();
        if (!link || !btn) return;

        /* Keep the label and the sold-out state in step with the real button.
           Both writes are guarded: the MutationObserver below reacts to DOM
           changes, and writing unconditionally would retrigger it forever. */
        var cells = link.querySelectorAll('x-cell');
        var slot = cells[cells.length - 1];
        var want = labelOf(btn);
        if (slot && slot.textContent.trim() !== want) slot.textContent = want;

        var off = !!btn.disabled;
        if (link.classList.contains('is-disabled') !== off) {
            link.classList.toggle('is-disabled', off);
        }

        if (link.dataset.parcuAdd) return;
        link.dataset.parcuAdd = '1';

        link.addEventListener('click', function (e) {
            var b = mainButton();
            /* No button found means the page is not in the state we expect;
               leave the anchor alone so it still jumps to the picker. */
            if (!b) return;
            e.preventDefault();
            if (b.disabled) return;
            b.click();
        });
    }

    /* --------------------------------------------------------
       CATEGORY BAR — Heavyweight Hoodies sits after New Arrivals

       parcu-header.js builds the row from SUBBAR_SOURCES: it takes
       the children of the "Heavyweight tees" menu first, then appends
       the "Heavyweight Hoodies" menu as a single entry. Appending is
       why Hoodies always lands last, after every colour, and there is
       no ordering option to change: the position is a consequence of
       the order of that array. Reordering the navigation menu cannot
       fix it either, because the two come from different sources.

       Moving the node after the fact is a much smaller change than
       rewriting the builder inside parcu-header.js, which is 27KB and
       would have to be resent in full for this one move.

       Matched on href rather than on the label, so this keeps working
       if the menu is ever translated. "/collections/heavyweight-hoodie"
       cannot collide with the All link at "/collections/heavyweight",
       and the substring match tolerates a locale prefix such as
       /es/collections/...
       -------------------------------------------------------- */

    function subbarOrder() {
        var ul = document.querySelector('.parcu-subbar ul');
        if (!ul || ul.dataset.parcuOrdered) return;

        var anchor = ul.querySelector('li a[href*="/collections/new-arrivals-heavyweight"]');
        var move = ul.querySelector('li a[href*="/collections/heavyweight-hoodie"]');
        if (!anchor || !move) return;

        var anchorLi = anchor.closest('li');
        var moveLi = move.closest('li');
        if (!anchorLi || !moveLi || anchorLi === moveLi) return;

        /* Set before moving. The move is a DOM change and so wakes the
           MutationObserver below, and the flag is what stops it from
           running again. */
        ul.dataset.parcuOrdered = '1';
        if (anchorLi.nextElementSibling !== moveLi) {
            anchorLi.insertAdjacentElement('afterend', moveLi);
        }
    }

    /* --------------------------------------------------------
       PRODUCT PAGE — rating line above "read all reviews"
       The link lives at the end of PRODUCT-PAGE-COLLAPSIBLE.liquid,
       a 75KB snippet, and the Shopify API has no way to patch part of
       a file. Inserting the line from here avoids resending all of it
       for one sentence. If that snippet is ever rewritten, move this
       line into it and delete this block.

       The wording is handed over by snippets/parcu-review-css.liquid
       as window.PARCU_I18N.reviewsRating, already translated for the
       shopper's country using the same country map the collapsible
       uses. Liquid cannot run inside a .js asset, so a string written
       here would be stuck in English everywhere. The English below is
       only a fallback for the case where the snippet has not run.

       The figures are deliberately static and rounded down. They are
       NOT read from the Judge.me badge on the page, because that badge
       is this product's rating, not the store's. Update the wording in
       snippets/parcu-review-css.liquid when the store totals move.
       -------------------------------------------------------- */

    var RATING_FALLBACK = 'rated 4.8 / 5 stars from over 2,000 verified reviews';

    function ratingText() {
        return (window.PARCU_I18N && window.PARCU_I18N.reviewsRating) || RATING_FALLBACK;
    }

    function ratingLine() {
        var wrap = document.querySelector('.parcu-reviews-link');
        if (!wrap || wrap.dataset.parcuRated) return;
        wrap.dataset.parcuRated = '1';

        var p = document.createElement('p');
        p.className = 'parcu-reviews-rating';
        p.textContent = ratingText();
        wrap.insertBefore(p, wrap.firstChild);
    }

    /* --------------------------------------------------------
       PRODUCT PAGE — show the score on the Judge.me star badge
       The badge renders as five stars plus "14 reviews", so 4.1 and
       4.9 look identical at a glance and a 4.8 reads as a clean five.
       Judge.me puts the real figure on the element as
       data-average-rating, so the number is its own, not ours.

       Rounded to one decimal, because "4.71" next to five stars reads
       as a spreadsheet rather than a rating.
       -------------------------------------------------------- */

    function badgeScore() {
        var badges = document.querySelectorAll('.jdgm-prev-badge[data-average-rating]');
        for (var i = 0; i < badges.length; i++) {
            var el = badges[i];
            if (el.dataset.parcuScore) continue;

            var avg = parseFloat(el.getAttribute('data-average-rating'));
            var n = parseInt(el.getAttribute('data-number-of-reviews'), 10);
            /* A product with no reviews yet reports 0, and the badge is
               hidden anyway. Writing "0.0" into it would be worse. */
            if (!avg || !n) continue;

            var stars = el.querySelector('.jdgm-prev-badge__stars');
            if (!stars) continue;

            el.dataset.parcuScore = '1';
            var span = document.createElement('span');
            span.className = 'parcu-badge-score';
            span.textContent = (Math.round(avg * 10) / 10).toFixed(1);
            el.insertBefore(span, stars);
        }
    }

    function boot() {
        wire();
        subbarOrder();
        ratingLine();
        badgeScore();
        /* Changing size re-renders the buy button, the price block
           re-renders the bar, and Judge.me paints its badge late, so
           re-run on DOM changes. parcu-header.js also builds the
           category row during its own DOMContentLoaded handler, so
           subbarOrder may well find nothing on the first pass and do
           its work here instead. Every write above is guarded against
           retriggering this observer. */
        if (!window.MutationObserver) return;
        new MutationObserver(function () { wire(); subbarOrder(); ratingLine(); badgeScore(); })
            .observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
